import { cx } from '$lib/utils/cx.js';

export function extractLinks(text: string) {
    const linkRegex =
        /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/g;
    let links = text.match(linkRegex);

    if (!links) {
        return [];
    }

    return links;
}

export type ImageSize = 'small' | 'medium' | 'big' | null;
export const IMAGE_SIZE = { SMALL: 'small', MEDIUM: 'medium', BIG: 'big' };

export const getImageSize = (width: number) => {
    if (width <= 480) return IMAGE_SIZE.SMALL;
    else if (width <= 768) return IMAGE_SIZE.MEDIUM;
    return IMAGE_SIZE.BIG;
};

export const sizeToInt = (s: string) => {
    if (s === IMAGE_SIZE.SMALL) return 1;
    else if (s === IMAGE_SIZE.MEDIUM) return 2;
    else return 3;
};

export function restrictSize(size: string, maxSize: string | null) {
    if (maxSize != null && sizeToInt(size) > sizeToInt(maxSize)) {
        return maxSize;
    } else {
        return size;
    }
}

export const getClasses = ({
    imageSize,
    linkClass,
}: {
    imageSize: string | null;
    linkClass: string | null;
}) => {
    if (imageSize === IMAGE_SIZE.SMALL || imageSize === null)
        return {
            linkClass: cx(
                'w-full border border-solid border-gray-300 rounded my-2 p-1 shadow-sm flex cursor-pointer hover:no-underline items-center',
                linkClass ?? '',
            ),
            imgClass: 'force-w-[60px] force-h-[60px] rounded object-cover',
            contentClass: 'px-6 py-4 overflow-hidden flex-auto',
        };

    if (imageSize === IMAGE_SIZE.MEDIUM)
        return {
            linkClass: cx(
                'w-full border border-solid border-gray-300 rounded my-2 p-1 shadow-sm flex cursor-pointer hover:no-underline items-center',
                linkClass ?? '',
            ),
            imgClass: 'force-w-[120px] force-h-[120px] rounded object-cover',
            contentClass: 'px-6 py-4 overflow-hidden flex-auto',
        };

    return {
        linkClass: cx(
            'block w-full border border-solid border-gray-300 rounded my-2 p-1 shadow-sm cursor-pointer hover:no-underline',
            linkClass ?? '',
        ),
        imgClass:
            'block force-w-full force-h-[200px] ls:force-h-[300px] rounded object-cover',
        contentClass: 'px-6 py-4 overflow-hidden',
    };
};
